// extracted by mini-css-extract-plugin
export var button = "_eo-4";
export var hasDarkBackground = "_eo-7";
export var hasLightBackground = "_eo-6";
export var iconWrapper = "_eo-0";
export var large = "_eo-2";
export var medium = "_eo-1";
export var small = "_eo-5";
export var xsmall = "_eo-3";